import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth, db } from '../firebase';
import './Auth.css';
import { ref, set } from "firebase/database";
import { nitrologo } from "../utilities/images";

const AuthHeader = () => (
  <header className="uber-auth-header">
    <Link to="/">
      <img src={nitrologo} alt="9troRide Logo" />
    </Link>
  </header>
);

function RideSignUp() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    if (!firstName || !lastName || !email || !password) {
      setError('Please fill in all fields.');
      return;
    }
    // ... (rest of validation)

    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await updateProfile(user, {
        displayName: `${firstName} ${lastName}`
      });

      const newRider = {
        uid: user.uid,
        email: user.email,
        first_name: firstName || '',
        last_name: lastName || '',
        created_at: Date.now(),
        // ... other default fields
      };

      await set(ref(db, 'riders/' + user.uid), newRider);
      navigate(from, { replace: true });
    } catch (error) {
      setError(error.message.replace('Firebase: ', ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="uber-auth-page-wrapper">
      <AuthHeader />
      <div className="uber-auth-container">
        <div className="auth-header">
          <h1>Create your account</h1>
        </div>
        <form onSubmit={handleSignUp} className="auth-form">
          {error && <p className="auth-error" style={{textAlign: 'center'}}>{error}</p>}
          <div className="auth-input-group">
            <div className="auth-input-wrapper">
              <input type="text" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
              <div className="auth-input-icons">
                {firstName && (
                  <button type="button" className="auth-input-icon-btn" onClick={() => setFirstName('')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="auth-input-group">
            <div className="auth-input-wrapper">
              <input type="text" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
              <div className="auth-input-icons">
                {lastName && (
                  <button type="button" className="auth-input-icon-btn" onClick={() => setLastName('')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="auth-input-group">
            <div className="auth-input-wrapper">
              <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <div className="auth-input-icons">
                {email && (
                  <button type="button" className="auth-input-icon-btn" onClick={() => setEmail('')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="auth-input-group">
            <div className="auth-input-wrapper">
              <input type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <div className="auth-input-icons">
                {password && (
                  <button type="button" className="auth-input-icon-btn" onClick={() => setPassword('')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                  </button>
                )}
                <button type="button" className="auth-input-icon-btn" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          <p className="auth-terms" style={{textAlign: 'left', fontSize: '12px', color: '#555'}}>
            By signing up, you agree to our <Link to="/terms" style={{textDecoration: 'underline', color: '#000'}}>Terms</Link> and <Link to="/privacy" style={{textDecoration: 'underline', color: '#000'}}>Privacy Policy</Link>.
          </p>
          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? 'Creating Account...' : 'Sign Up'}
          </button>
        </form>
        <div className="auth-redirect">
          <p>Already have an account? <Link to="/ride-login" state={{ from: location.state?.from }}>Log in</Link></p>
        </div>
      </div>
    </div>
  );
}

export default RideSignUp;